// BraveAim - Main JavaScript

// Aguarda o carregamento completo do DOM
document.addEventListener('DOMContentLoaded', function() {

    // Inicializa os componentes
    initMobileMenu();
    initDropdown();
    // initProductVideos() disabled — the homepage IntersectionObserver in
    // custom-home.liquid is the sole controller for .container-video. This legacy
    // hover/checkpoint controller reset the folder animation to frame 0 on 'ended'.
    // initProductVideos();
    initProductPageVideo();
    initScrollAnimations();

});

/**
 * Inicializa animações ao scroll (Intersection Observer)
 */
function initScrollAnimations() {
    const communitySection = document.querySelector('.community-container');

    if (!communitySection) return;

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    observer.observe(communitySection);
}

/**
 * Inicializa o menu mobile sidebar
 */
function initMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const mainNav = document.getElementById('mainNav');
    const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');

    if (!mobileMenuBtn || !mainNav) return;

    // Toggle menu ao clicar no botão hamburger
    mobileMenuBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        mainNav.classList.toggle('active');
        if (mobileMenuOverlay) {
            mobileMenuOverlay.classList.toggle('active');
        }
        document.body.style.overflow = mainNav.classList.contains('active') ? 'hidden' : '';
    });

    // Fecha menu ao clicar no overlay
    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', function() {
            mainNav.classList.remove('active');
            mobileMenuOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Fecha menu ao clicar em um link
    const navLinks = mainNav.querySelectorAll('.nav-link:not(.dropdown-toggle)');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            mainNav.classList.remove('active');
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('active');
            }
            document.body.style.overflow = '';
        });
    });

    // Fecha menu ao pressionar ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mainNav.classList.contains('active')) {
            mainNav.classList.remove('active');
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('active');
            }
            document.body.style.overflow = '';
        }
    });

    // Fecha menu ao redimensionar para desktop
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && mainNav.classList.contains('active')) {
            mainNav.classList.remove('active');
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('active');
            }
            document.body.style.overflow = '';
        }
    });
}

/**
 * Inicializa o comportamento do dropdown do menu
 */
function initDropdown() {
    const dropdown = document.querySelector('.dropdown');
    const dropdownToggle = dropdown?.querySelector('.dropdown-toggle');
    const dropdownMenu = dropdown?.querySelector('.dropdown-menu');

    if (!dropdown || !dropdownToggle || !dropdownMenu) return;

    // Toggle dropdown ao clicar
    dropdownToggle.addEventListener('click', function(e) {
        e.preventDefault();

        // Adiciona/remove classe active
        dropdown.classList.toggle('active');
    });

    // Fecha dropdown ao clicar fora
    document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('active');
        }
    });

    // Fecha dropdown ao pressionar ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            dropdown.classList.remove('active');
        }
    });
}

/* initDiscordButton removed 2026-07-14 — the .btn-discord buttons are now
   real Sign in / My Library links (see header sign-in block). The old handler
   preventDefault()'d the FIRST .btn-discord on the page, which is the MOBILE
   menu button, so tapping Sign in on mobile did nothing while desktop worked. */

/**
 * Adiciona indicador de scroll no header
 */
window.addEventListener('scroll', function() {
    const header = document.querySelector('.header');

    if (window.scrollY > 50) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

/**
 * Marca o link ativo baseado na página atual
 */
function setActiveLink() {
    const currentPage = window.location.pathname.split('/').pop() || 'main.html';
    const navLinks = document.querySelectorAll('.nav-link');

    navLinks.forEach(link => {
        const href = link.getAttribute('href');

        if (href === currentPage || (href === '#' && currentPage === 'main.html')) {
            link.classList.add('active');
        } else {
            link.classList.remove('active');
        }
    });
}

// Executa ao carregar
setActiveLink();













document.addEventListener('DOMContentLoaded', function () {
      const btnWrappers = document.querySelectorAll('.btn-wrapper, .unreal-btn-wrapper, .motion-btn-wrapper');

      btnWrappers.forEach(function (btnWrapper) {
        const btn = btnWrapper.querySelector('.btn, .unreal-btn, .motion-btn');

        btn.addEventListener('click', function (e) {
          e.preventDefault();

          // Verifica se o botão tem um link de destino
          const targetUrl = btnWrapper.getAttribute('data-url');

          if (targetUrl) {
            // Adiciona classe active para feedback visual
            btnWrapper.classList.add('active');

            // Aguarda 7 segundos antes de redirecionar
            setTimeout(function() {
              window.location.href = targetUrl;
            }, 7000);
          } else {
            // Comportamento original se não tiver URL
            btnWrapper.classList.toggle('active');
          }
        });
      });

      // Close when clicking outside
      document.addEventListener('click', function (e) {
        btnWrappers.forEach(function (btnWrapper) {
          if (!btnWrapper.contains(e.target)) {
            btnWrapper.classList.remove('active');
          }
        });
      });
    });

/**
 * FAQ Accordion Functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');

    question.addEventListener('click', function() {
      // Toggle current item
      const isActive = item.classList.contains('active');

      // Close all items
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('active');
      });

      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });
});

/**
 * Product Details Dropdown Functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const detailDropdowns = document.querySelectorAll('.detail-dropdown');

  detailDropdowns.forEach(dropdown => {
    const header = dropdown.querySelector('.detail-dropdown-header');

    header.addEventListener('click', function() {
      // Toggle current dropdown
      dropdown.classList.toggle('active');
    });
  });
});



/**
 * Product Videos Hover Functionality - Checkpoint Style
 */
function initProductVideos() {
  const cardContainers = document.querySelectorAll('.card-container');

  cardContainers.forEach(container => {
    const video = container.querySelector('.container-video');
    if (!video) return;

    // Configuração inicial
    video.pause();
    video.currentTime = 0;
    video.loop = false; // Desativamos o loop nativo para controlar o reset manualmente

    container.addEventListener('mouseenter', function() {
      // 1. Se o vídeo estiver no fim ou no começo, garante que inicia do zero
      if (video.currentTime >= video.duration || video.currentTime === 0) {
        video.currentTime = 0;
      }
      
      video.play();

      // 2. Cria a trava para parar em 1:13 (73 segundos)
      video.ontimeupdate = () => {
        if (video.currentTime >= 73) {
          video.pause();
          video.currentTime = 73;
          video.ontimeupdate = null; // Remove a trava após atingir o ponto
        }
      };
    });

    container.addEventListener('mouseleave', function() {
      // 3. Ao tirar o mouse, remove qualquer trava pendente e manda o vídeo seguir
      video.ontimeupdate = null; 
      video.play(); 
    });

    // 4. Quando o vídeo chegar ao fim total, reseta para o frame 0 e pausa
    video.onended = () => {
      video.pause();
      video.currentTime = 0;
    };
  });
}

// initProductVideos() disabled — see note in the DOMContentLoaded init block above.
// initProductVideos();



/**
 * Product Page Video Click Functionality
 */
function initProductPageVideo() {
  const productVideo = document.querySelector('.product-main-image');

  if (!productVideo || productVideo.tagName !== 'VIDEO') return;

  let isPlaying = true; // Começa playing pois tem autoplay
  let isReversing = false;
  let reverseInterval = null;

  productVideo.addEventListener('click', function() {
    // Cancela qualquer reversão em andamento
    if (reverseInterval) {
      clearInterval(reverseInterval);
      reverseInterval = null;
    }

    if (!isPlaying) {
      // Ativa o vídeo
      isPlaying = true;
      isReversing = false;
      productVideo.play();
    } else {
      // Desativa o vídeo e reverte
      isPlaying = false;
      isReversing = true;
      reverseInterval = reverseVideo(productVideo, function() {
        isReversing = false;
        reverseInterval = null;
      });
    }
  });

  productVideo.addEventListener('ended', function() {
    isPlaying = false;
    productVideo.pause();
  });
}

/**
 * Video Comparison Slider Functionality (suporta múltiplos sliders)
 */
function initComparisonSlider() {
  const sliders = document.querySelectorAll('.comparison-slider');
  if (!sliders.length) return;

  sliders.forEach(slider => {
    const afterLayer = slider.querySelector('.comparison-after');
    const handle = slider.querySelector('.comparison-handle');
    let isDragging = false;

    function updateSliderPosition(clientX) {
      const rect = slider.getBoundingClientRect();
      let position = (clientX - rect.left) / rect.width;
      position = Math.max(0.05, Math.min(0.95, position));
      const percentage = position * 100;
      afterLayer.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
      handle.style.left = `${percentage}%`;
    }

    function startDrag(e) {
      isDragging = true;
      slider.classList.add('dragging');
      e.preventDefault();
    }

    function stopDrag() {
      if (isDragging) {
        isDragging = false;
        slider.classList.remove('dragging');
      }
    }

    function onDrag(e) {
      if (!isDragging) return;
      let clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      updateSliderPosition(clientX);
    }

    // Mouse events
    slider.addEventListener('mousedown', function(e) {
      startDrag(e);
      updateSliderPosition(e.clientX);
    });

    slider.addEventListener('mousemove', onDrag);
    slider.addEventListener('mouseleave', stopDrag);
    document.addEventListener('mouseup', stopDrag);

    // Touch events
    slider.addEventListener('touchstart', function(e) {
      startDrag(e);
      updateSliderPosition(e.touches[0].clientX);
    }, { passive: false });

    slider.addEventListener('touchmove', function(e) {
      if (isDragging) {
        e.preventDefault();
        onDrag(e);
      }
    }, { passive: false });

    slider.addEventListener('touchend', stopDrag);

    // Sincroniza os vídeos
    const videos = slider.querySelectorAll('.comparison-video');
    videos.forEach(video => {
      video.addEventListener('loadeddata', function() {
        video.currentTime = 0;
      });
    });
  });
}

// Inicializa o comparison slider quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', initComparisonSlider);

/**
 * Game Changing Enhancements - Video Switcher
 */
function initEnhancements() {
  const buttons = document.querySelectorAll('.enhancement-btn');
  const video = document.getElementById('enhancementVideo');

  if (!buttons.length || !video) return;

  let currentIndex = 0;
  let autoSwitchInterval;

  function switchTo(index) {
    // Remove active de todos
    buttons.forEach(btn => btn.classList.remove('active'));

    // Adiciona active no atual
    buttons[index].classList.add('active');

    // Pega o video key e atualiza o vídeo
    const videoKey = buttons[index].dataset.video;
    const videoLinks = {
      'hairtriggers': 'https://cdn.shopify.com/videos/c/o/v/db297cb91c3842b3920e2063ac6268fa.mp4',
      'yyspam': 'https://cdn.shopify.com/videos/c/o/v/94fc4e5e649d4ae5856821af7780840d.mp4',
      'rapidfire': 'https://cdn.shopify.com/videos/c/o/v/4f21c6d13571482da912d60a866f3bd7.mp4',
      'slidecancel': 'https://cdn.shopify.com/videos/c/o/v/99f38b8860914c2ba140877b586f421a.mp4',
      'autoping': 'https://cdn.shopify.com/videos/c/o/v/0ce3218d9afe45c1a7f1ad578a7b9a05.mp4',
      'bunnyhop': 'https://cdn.shopify.com/videos/c/o/v/927c4181f282454eb660cda5bb8d93d1.mp4'
    };
    video.src = videoLinks[videoKey] || `assets/videos/${videoKey}.mp4`;
    video.load();
    video.play();

    currentIndex = index;
  }

  function nextEnhancement() {
    const nextIndex = (currentIndex + 1) % buttons.length;
    switchTo(nextIndex);
  }

  function startAutoSwitch() {
    autoSwitchInterval = setInterval(nextEnhancement, 6000);
  }

  function resetAutoSwitch() {
    clearInterval(autoSwitchInterval);
    startAutoSwitch();
  }

  // Click nos botões
  buttons.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      switchTo(index);
      resetAutoSwitch();
    });
  });

  // Inicia o auto switch
  startAutoSwitch();
}

// Inicializa enhancements quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', initEnhancements);

/**
 * Unreal Page - Comparison Tabs (troca vídeos ANTI RECOIL / AUTO TRACK)
 */
function initUnrealComparisonTabs() {
  const tabs = document.querySelectorAll('.unreal-comparison .comparison-tab-btn');
  const beforeVideo = document.getElementById('unrealBeforeVideo');
  const afterVideo = document.getElementById('unrealAfterVideo');

  if (!tabs.length || !beforeVideo || !afterVideo) return;

  const videoSources = {
    antirecoil: {
      before: 'https://cdn.shopify.com/videos/c/o/v/8a86d0afaa0f414e9dc0b544f57c894a.webm',
      after: 'https://cdn.shopify.com/videos/c/o/v/9415dace2a9f4a379c5df4e1c224b96e.webm'
    },
    autotrack: {
      before: 'https://cdn.shopify.com/videos/c/o/v/016112eb00124dcd886a88afcdbd9121.webm',
      after: 'https://cdn.shopify.com/videos/c/o/v/81e49a5f22eb4815a7c8baebe9a4bc0f.webm'
    }
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Remove active de todos os tabs
      tabs.forEach(t => t.classList.remove('active'));
      // Adiciona active no tab clicado
      this.classList.add('active');

      // Pega o tab key e atualiza os vídeos
      const tabKey = this.getAttribute('data-tab');
      const sources = videoSources[tabKey];

      if (sources) {
        beforeVideo.querySelector('source').src = sources.before;
        afterVideo.querySelector('source').src = sources.after;
        beforeVideo.load();
        afterVideo.load();
        beforeVideo.play();
        afterVideo.play();
      }
    });
  });
}

// Inicializa Unreal Comparison Tabs quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', initUnrealComparisonTabs);

/**
 * Unreal Page - Enhancements Video Switcher (4 botões)
 */
function initUnrealEnhancements() {
  const buttons = document.querySelectorAll('.unreal-enhancements .enhancement-btn');
  const video = document.getElementById('unrealEnhancementVideo');

  if (!buttons.length || !video) return;

  const videoSources = {
    editmacro: 'https://cdn.shopify.com/videos/c/o/v/d39b171793b0436f9f7a9099a096823a.mp4',
    hairtriggers_unreal: 'https://cdn.shopify.com/videos/c/o/v/afd9d8c01d8c4ec2a8f45a879a0c79db.mp4',
    pickupmacro: 'https://cdn.shopify.com/videos/c/o/v/c857b373a6f4420eaaa61a9a83e5711e.mp4',
    dropshotmacro: 'https://cdn.shopify.com/videos/c/o/v/55f1ec6ae0e04ecdac8caf43f68d2724.mp4'
  };

  let currentIndex = 0;
  let autoSwitchInterval;

  function switchTo(index) {
    buttons.forEach(btn => btn.classList.remove('active'));
    buttons[index].classList.add('active');

    const videoKey = buttons[index].getAttribute('data-video');
    const source = videoSources[videoKey];

    if (source) {
      video.querySelector('source').src = source;
      video.load();
      video.play();
    }

    currentIndex = index;
  }

  function nextEnhancement() {
    const nextIndex = (currentIndex + 1) % buttons.length;
    switchTo(nextIndex);
  }

  function startAutoSwitch() {
    autoSwitchInterval = setInterval(nextEnhancement, 3000);
  }

  function resetAutoSwitch() {
    clearInterval(autoSwitchInterval);
    startAutoSwitch();
  }

  buttons.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      switchTo(index);
      resetAutoSwitch();
    });
  });

  startAutoSwitch();
}

// Inicializa Unreal Enhancements quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', initUnrealEnhancements);

/**
 * Motion Page - Shooting Mods Section (4 botões, auto-switch 6s)
 */
function initMotionShootingMods() {
  const buttons = document.querySelectorAll('.motion-shooting-section .enhancement-btn');
  const video = document.getElementById('motionShootingVideo');
  const nameEl = document.getElementById('motionShootingName');
  const descEl = document.getElementById('motionShootingDesc');

  if (!buttons.length || !video || !nameEl || !descEl) return;

  const shootingData = {
    autogreen: {
      name: 'Auto Green',
      description: 'Automatically times every shot, every time.',
      video: 'https://cdn.shopify.com/videos/c/o/v/4f5642b4d3454cbda2fdf6dc178c0e35.mp4'
    },
    autofades: {
      name: 'Auto Fades',
      description: 'Perfect fade timing for unstoppable jumpers.',
      video: 'https://cdn.shopify.com/videos/c/o/v/3bd38d46746344a9b0de3f0db901bd74.mp4'
    },
    autonodip: {
      name: 'Auto No-Dip',
      description: 'Eliminates shot dip for faster release.',
      video: 'https://cdn.shopify.com/videos/c/o/v/f8ebb8d3dc544ec8a0ebb41cde13def4.mp4'
    },
    buttonrhythm: {
      name: 'Button Rhythm',
      description: 'Master the rhythm timing for consistent greens.',
      video: 'https://cdn.shopify.com/videos/c/o/v/0a1bd104b8ef4dd3a8459c9e4da478a2.mp4'
    }
  };

  let currentIndex = 0;
  let autoSwitchInterval;

  function switchTo(index) {
    buttons.forEach(btn => btn.classList.remove('active'));
    buttons[index].classList.add('active');

    const videoKey = buttons[index].getAttribute('data-video');
    const data = shootingData[videoKey];

    if (data) {
      nameEl.textContent = data.name;
      descEl.textContent = data.description;
      video.querySelector('source').src = data.video;
      video.load();
      video.play();
    }

    currentIndex = index;
  }

  function nextItem() {
    const nextIndex = (currentIndex + 1) % buttons.length;
    switchTo(nextIndex);
  }

  function startAutoSwitch() {
    autoSwitchInterval = setInterval(nextItem, 6000);
  }

  function resetAutoSwitch() {
    clearInterval(autoSwitchInterval);
    startAutoSwitch();
  }

  buttons.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      switchTo(index);
      resetAutoSwitch();
    });
  });

  startAutoSwitch();
}

/**
 * Motion Page - Game Changing Enhancements Section (6 botões, auto-switch 6s)
 */
function initMotionEnhancements() {
  const buttons = document.querySelectorAll('.motion-gamechanging-section .enhancement-btn');
  const video = document.getElementById('motionEnhancementVideo');
  const nameEl = document.getElementById('motionEnhancementName');
  const descEl = document.getElementById('motionEnhancementDesc');

  if (!buttons.length || !video || !nameEl || !descEl) return;

  const enhancementData = {
    infinitestamina: {
      name: 'Infinite Stamina',
      description: 'Never run out of stamina during intense gameplay.',
      video: 'https://cdn.shopify.com/videos/c/o/v/08fa84622cf74333a1ca252fe7d46b57.mp4'
    },
    autoquickstop: {
      name: 'Auto Quickstop',
      description: 'Automatically triggers a perfect quickstop for clean, controlled jump shots.',
      video: 'https://cdn.shopify.com/videos/c/o/v/d36185093a7f49da8ed680333455a791.mp4'
    },
    l2quickstop: {
      name: 'L2 Quickstop',
      description: 'Execute precise L2 quickstops with perfect timing.',
      video: 'https://cdn.shopify.com/videos/c/o/v/aef748bdd14849bdb9bdcd3ae568651d.mp4'
    },
    meterdunk: {
      name: 'Meter Dunk',
      description: 'Perfect timing for powerful dunks every time.',
      video: 'https://cdn.shopify.com/videos/c/o/v/4cefa071df52467797b322d063dfb626.mp4'
    },
    autodribbles: {
      name: 'Auto Dribbles',
      description: 'Execute complex dribble moves automatically.',
      video: 'https://cdn.shopify.com/videos/c/o/v/8c3ac218cca64c0082a08ae5300a7e8e.mp4'
    },
    defenseassist: {
      name: 'Defense Assist',
      description: 'Enhanced defensive reactions and positioning.',
      video: 'https://cdn.shopify.com/videos/c/o/v/5b472c435b454a5484147c53f272adf8.mp4'
    }
  };

  let currentIndex = 0;
  let autoSwitchInterval;

  function switchTo(index) {
    buttons.forEach(btn => btn.classList.remove('active'));
    buttons[index].classList.add('active');

    const videoKey = buttons[index].getAttribute('data-video');
    const data = enhancementData[videoKey];

    if (data) {
      nameEl.textContent = data.name;
      descEl.textContent = data.description;
      video.querySelector('source').src = data.video;
      video.load();
      video.play();
    }

    currentIndex = index;
  }

  function nextItem() {
    const nextIndex = (currentIndex + 1) % buttons.length;
    switchTo(nextIndex);
  }

  function startAutoSwitch() {
    autoSwitchInterval = setInterval(nextItem, 6000);
  }

  function resetAutoSwitch() {
    clearInterval(autoSwitchInterval);
    startAutoSwitch();
  }

  buttons.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      switchTo(index);
      resetAutoSwitch();
    });
  });

  startAutoSwitch();
}

// Inicializa Motion Sections quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', initMotionShootingMods);
document.addEventListener('DOMContentLoaded', initMotionEnhancements);

/**
 * Purchase Button - Adiciona ao carrinho e vai para /cart
 */
document.addEventListener('DOMContentLoaded', function() {
  const purchaseButtons = document.querySelectorAll('.product-purchase-btn');

  purchaseButtons.forEach(button => {
    button.addEventListener('click', function() {
      const productHandle = this.getAttribute('data-product-handle');

      if (!productHandle) return;

      // Busca o produto para pegar o variant ID
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          const variantId = product.variants[0].id;

          // Adiciona ao carrinho
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        })
        .then(response => response.json())
        .then(data => {
          // Redireciona para o carrinho
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Erro ao adicionar ao carrinho:', error);
        });
    });
  });
});